import type * as React from 'react';

import { SiteType } from '@gitbook/api-client';
import {
    GradientEllipse,
    PageSplit,
    PageSplitAside,
    PageSplitBody,
    PageSplitMain,
} from '@gitbook/spine-react';

import { Preview } from '../../Components/CreateSite';

export function WelcomeLayout(props: {
    children: React.ReactNode;
    title?: string;
}): React.ReactElement {
    return (
        <PageSplit>
            <PageSplitMain>
                <PageSplitBody size="medium">{props.children}</PageSplitBody>
            </PageSplitMain>
            <PageSplitAside
                className="overflow-visible"
                customGradient={
                    <GradientEllipse className="pointer-events-none absolute top-0 left-12 size-full scale-[2] xl:pt-20 dark:opacity-50" />
                }
            >
                {typeof props.title === 'string' ? (
                    <Preview
                        stepperType={'new-pricing'}
                        step="features"
                        inputs={{
                            name: props.title ? `${props.title} Docs` : 'Org Docs',
                            features: {
                                plan: SiteType.Ultimate,
                                previewPublishOutcome: {
                                    type: 'checkout',
                                },
                            },
                            content: 'empty',
                            publish: 'later',
                            withVA: false,
                        }}
                    />
                ) : null}
            </PageSplitAside>
        </PageSplit>
    );
}
